import { Component, Input, HostListener } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
    standalone: false,
    selector: 'model-page',
    templateUrl: './model-page.component.html',
    styleUrls: ['./model-page.component.css'],
})
export class ModelPageComponent {
    @Input() model: any;
    @Input() form!: NgForm;

    public showModel: boolean = false;

    public get errors(): any {
        let errors = {};
        if (this.form) {
            const controls = this.form.controls;
            Object.keys(controls).filter(x => controls[x].errors).forEach(x => errors[x] = controls[x].errors);
        }
        return errors;
    }

    constructor() { }

    @HostListener('window:keypress', ['$event'])
    onKeyPress(e: any) {
        // Ctrl-Shift-A
        if (e.which == 1 && e.ctrlKey && e.shiftKey) {
            this.showModel = true;
        }
    }

    onClose() {
        this.showModel = false;
    }
}
